<div class="dialog-container">
    <div class="dialog-header">
        <div class="header-icon">
            <mat-icon>edit</mat-icon>
        </div>
        <div class="header-content">
            <h2 class="dialog-title">Update Trucks</h2>
            <p class="dialog-subtitle">Booking <strong>{{ data.order.ref }}</strong></p>
        </div>
    </div>

    <div class="dialog-body">
        <!-- Currently assigned -->
        <div class="section-label">
            <mat-icon>local_shipping</mat-icon>
            <span>Assigned Trucks</span>
        </div>

        <div class="assigned-list" *ngIf="assignedTrucks.length > 0; else noAssigned">
            <div
                class="assigned-item"
                *ngFor="let truck of assignedTrucks"
                [class.marked-remove]="isMarkedForUnassign(truck.id)"
            >
                <mat-icon class="truck-icon">local_shipping</mat-icon>
                <span class="truck-label">{{ truck.plateNumber }} <span class="truck-type-badge">{{ truck.truckType }}</span></span>
                <button
                    class="btn-toggle-remove"
                    [class.active]="isMarkedForUnassign(truck.id)"
                    (click)="toggleUnassign(truck.id)"
                    [title]="isMarkedForUnassign(truck.id) ? 'Keep this truck' : 'Unassign this truck'"
                >
                    <mat-icon>{{ isMarkedForUnassign(truck.id) ? 'undo' : 'close' }}</mat-icon>
                </button>
            </div>
        </div>
        <ng-template #noAssigned>
            <p class="empty-text">No trucks currently assigned.</p>
        </ng-template>

        <div *ngIf="unassignIds.length > 0" class="removal-hint">
            <mat-icon>info</mat-icon>
            <span>{{ unassignIds.length }} truck(s) will be unassigned</span>
        </div>

        <!-- Add new trucks -->
        <div class="section-label" style="margin-top: 20px">
            <mat-icon>add_circle</mat-icon>
            <span>Add New Trucks</span>
        </div>

        <div class="limit-hint" *ngIf="unassignIds.length === 0">
            <mat-icon>info</mat-icon>
            <span>Remove an assigned truck first to add a new one</span>
        </div>
        <div class="limit-hint slots-available" *ngIf="unassignIds.length > 0">
            <mat-icon>info</mat-icon>
            <span>You can add up to <strong>{{ unassignIds.length }}</strong> truck(s) — {{ availableSlots }} slot(s) remaining</span>
        </div>

        <div class="search-wrapper">
            <mat-icon class="search-icon">search</mat-icon>
            <input
                type="text"
                class="search-input"
                [(ngModel)]="searchText"
                placeholder="Search available trucks..."
            />
            <mat-icon *ngIf="searchText" class="clear-icon" (click)="searchText = ''">close</mat-icon>
        </div>

        <div class="truck-list-container">
            <mat-selection-list [(ngModel)]="newTruckIds" class="truck-selection-list">
                <mat-list-option
                    *ngFor="let truck of filteredAvailable"
                    [value]="truck.id"
                    class="truck-option"
                    [class.option-disabled]="isNewDisabled(truck.id)"
                    [disabled]="isNewDisabled(truck.id)"
                    [title]="isUndersized(truck) ? 'Truck capacity is below the minimum required for this booking' : ''"
                >
                    <div class="truck-item">
                        <mat-icon class="truck-icon">local_shipping</mat-icon>
                        <span class="truck-name">{{ truck.name }}</span>
                    </div>
                </mat-list-option>
            </mat-selection-list>
            <div *ngIf="filteredAvailable.length === 0" class="empty-message">
                <mat-icon>search_off</mat-icon>
                <p>No available trucks found</p>
            </div>
        </div>

        <div class="selected-count" *ngIf="newTruckIds.length > 0">
            <mat-icon>check_circle</mat-icon>
            <span>{{ newTruckIds.length }} / {{ unassignIds.length }} new truck(s) will be added</span>
        </div>
    </div>

    <div class="dialog-actions">
        <button class="btn-cancel" (click)="onCancel()">Cancel</button>
        <button class="btn-primary" (click)="onConfirm()" [disabled]="!hasChanges">
            <mat-icon>save</mat-icon>
            <span>Save Changes</span>
        </button>
    </div>
</div>
